var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-modal',{attrs:{"columns":_vm.COLUMNS_VVHWC,"output-columns":_vm.OUTPUT_COLUMNS_VVHWC,"validation-rules":_vm.VALIDATION_RULES_VVHWC,"always-included-columns":_vm.alwaysIncludedColumns,"tab-name":_vm.VVHWC_TAB_NAME}})}
var staticRenderFns = []

export { render, staticRenderFns }